// extracted by mini-css-extract-plugin
export default {"Subprocessors":"sLw5WJQn4TVIK4zzAid7","h2":"S9Igd3qcAG658DULu9lR","SubprocessorsOverflow":"WqaHpnNhJyndAmsWJYr6"};